export const locale = {
    lang: 'pt',
    data: {
        MODAL_CREATE_RATING: {
            TITLE: 'Avaliar o pedido',
            SUB_TITLE: 'Ajude a melhorar nossos serviços avaliando seu pedido.',
            COMMENTS: 'Comentário e Sugestão',
            MODAL: {
                BUTTONS: {
                    CANCEL: 'Cancelar',
                    SAVE: 'Salvar'
                }
            }
        },
    },
};
